'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import type { MarkdownContent } from '..';
import type { DbAttachment } from '../AttachmentsManager';
export type MarkdownEditorState = {
  markdown: string;
  attachments: DbAttachment[];
};
const getStorageKey = () => {
  if (globalThis.window === undefined) return '';
  return `markdownEditorContent-${globalThis.location.pathname}`;
};
const saveContentToLocalStorage = (content: MarkdownEditorState) => {
  if (!globalThis.window) return;
  try {
    localStorage.setItem(getStorageKey(), JSON.stringify(content));
  } catch (error) {
    console.error('Failed to save editor content to localStorage', error);
  }
};
const loadContentFromLocalStorage = (): MarkdownEditorState | null => {
  if (!globalThis.window) return null;
  try {
    const data = localStorage.getItem(getStorageKey());
    if (!data) return null;
    return JSON.parse(data) as MarkdownEditorState;
  } catch (error) {
    console.error('Failed to load editor content from localStorage', error);
    return null;
  }
};
export function useEditorLocalStorage(value) {
  const $ = _c(10);
  let t0;
  if ($[0] !== value) {
    t0 = () => value ?? {
      markdown: "",
      attachments: []
    };
    $[0] = value;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [initialValue, setInitialValue] = useState(t0);
  let t1;
  let t2;
  if ($[2] !== value) {
    t1 = () => {
      const stored = loadContentFromLocalStorage();
      if (!value && stored) {
        setInitialValue(stored);
      }
    };
    t2 = [value];
    $[2] = value;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[5] !== value) {
    t3 = () => {
      if (!value) {
        return;
      }
      const interval = setInterval(() => {
        saveContentToLocalStorage({
          markdown: value.markdown,
          attachments: value.attachments ?? []
        });
      }, 30000);
      return () => clearInterval(interval);
    };
    t4 = [value];
    $[5] = value;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== initialValue) {
    t5 = [initialValue, setInitialValue];
    $[8] = initialValue;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5 as const;
}